export default __webpack_public_path__ + "static/new-window-after-aaff69f0a85ee905a52e1c995b69325e.png";